import { Gift } from 'lucide-react';
import { REWARD_AMOUNT } from '../lib/rewards';

interface RewardBannerProps {
  /** 'create' = listing-creation flow, 'detail' = listing detail page. */
  variant?: 'create' | 'detail';
  className?: string;
}

/**
 * Tasteful, non-blocking banner surfacing the reward incentive:
 * "Sell it here and get $15 toward a new wig at MyHairMail when it sells."
 */
function RewardBanner({ variant = 'detail', className = '' }: RewardBannerProps) {
  const message =
    variant === 'create'
      ? `Sell it here and get $${REWARD_AMOUNT} toward a new wig at MyHairMail when it sells.`
      : `Sellers earn $${REWARD_AMOUNT} toward a new wig at MyHairMail when an item sells here.`;

  return (
    <div
      className={`flex items-center gap-3 rounded-lg border border-rose-100 bg-rose-50 px-4 py-3 ${className}`}
      role="note"
    >
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-rose-100 flex items-center justify-center">
        <Gift className="h-4 w-4 text-rose-600" />
      </div>
      <p className="text-sm text-rose-800">{message}</p>
    </div>
  );
}

export default RewardBanner;
